import { PageContainer } from '@/components'
import { useRouteIdParam } from '@/hooks'

import { ScenarioDetailsContent, ScenarioDetailsMenuBar } from './components'
import { useScenarioDetails, useScenarioDetailsForm } from './hooks'

export const ScenarioDetailsPage = () => {
  const projectId = useRouteIdParam('projectId') || 0
  const scenarioId = useRouteIdParam('scenarioId') || 0

  const { scenarioInfo, isFetching } = useScenarioDetails(projectId, scenarioId)

  const { formControl, isFormDisabled, isFormValid } =
    useScenarioDetailsForm(scenarioInfo)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { path: '/projects', title: 'Projects' },
            {
              path: `/projects/${projectId}`,
              title: scenarioInfo?.projectName || ''
            },
            { path: `/projects/${projectId}`, title: 'Scenarios' },
            { title: scenarioInfo?.name || '' }
          ]}
        />
      }
      menuBar={
        !!scenarioInfo && (
          <ScenarioDetailsMenuBar
            projectId={projectId}
            scenarioId={scenarioInfo.id}
            isScenarioValid={isFormValid}
          />
        )
      }>
      <ScenarioDetailsContent
        formControl={formControl}
        scenarioInfo={scenarioInfo}
        isFormDisabled={isFormDisabled}
      />
    </PageContainer>
  )
}
